export const RESIDENT_RELATIONSHIPS = [
    { value: 'owner', label: 'Owner' },
    { value: 'tenant', label: 'Tenant' },
    { value: 'family', label: 'Family Member' },
    { value: 'unknown', label: 'Unknown' },
];
export const createPropertyResidentState = () => ({
    id: null,
    name: '',
    relationship: 'unknown',
    yearFrom: '',
    yearTo: '',
    notes: '',
});
